/**
 * EvalFitPreview — a NO-LOGIN, dev/preview-host-only harness to verify the map
 * AUTO FIT-TO-FRAME (#1) WITHOUT auth. It mounts FloorBoundaryTracer directly
 * (enableZoom) with a fake plan inside the REAL workspace pane structure
 * (.evalws-fullscreen → .evalws → panes → .evalws-mappane → .evalws-marking), so
 * the runtime height-measure (ResizeObserver in the tracer) runs and the stage
 * `.evalws-plan-stage` can be measured against the pane bottom. Gated like the
 * other previews. The plan IMAGE won't load (empty URL) — irrelevant; we measure
 * the stage BOX dimensions + that the whole box fits the pane.
 */
import FloorBoundaryTracer from '../components/FloorBoundaryTracer';
import { previewRouteAllowed } from '../lib/previewHost';
import NotFound from './NotFound';
import type { FloorPlan } from '../lib/floorPlan';

const PLAN: FloorPlan = {
  storagePath: 'preview/fake.png',
  downloadURL: '',
  contentType: 'image/png',
  width: 632,
  height: 678, // aspect 0.933 — the coordinator's measured plan
};
const BOUNDARY = [
  { x: 40, y: 40 },
  { x: 592, y: 40 },
  { x: 592, y: 638 },
  { x: 40, y: 638 },
];
const noop = () => {};

export default function EvalFitPreview() {
  if (!previewRouteAllowed()) return <NotFound />;
  return (
    <div className="evalws-fullscreen">
      <div className="evalws">
        {/* a fake Row 1 + Row 2 chrome so the pane's available height is realistic */}
        <header className="evalws-idheader"><span className="evalws-eyebrow">Fit preview</span></header>
        <div className="evalws-panes" style={{ ['--evalws-left' as string]: '60fr', ['--evalws-right' as string]: '40fr' }}>
          <div className="evalws-mappane">
            <div className="evalws-marking">
              <div className="card flat" style={{ padding: 0 }}>
                <div data-testid="auo-workspace-eval">
                  <FloorBoundaryTracer
                    floorplan={PLAN}
                    boundary={BOUNDARY}
                    north={0}
                    onUpload={noop}
                    onPickProjectFile={noop}
                    onClearPlan={noop}
                    onEditPlan={noop}
                    onChangeBoundary={noop}
                    onAddEntrance={noop}
                    onAddInternalEntrance={noop}
                    onAddAuo={noop}
                    onAddMarkup={noop}
                    onMoveMarkup={noop}
                    onResizeMarkup={noop}
                    onRemoveMarkup={noop}
                    markups={[]}
                    enableZoom
                  />
                </div>
              </div>
            </div>
          </div>
          <aside className="evalws-refpane" />
        </div>
        <footer className="evalws-footer"><button type="button" className="evalws-btn evalws-btn-commit">Save evaluation</button></footer>
      </div>
    </div>
  );
}
